<script setup lang="ts">
import { ref } from 'vue';
import useValidators from 'src/shared/composables/useValidators';
import BInput from 'src/shared/components/base/BInput/BInput.vue';
import BButton from 'src/shared/components/base/BButton/BButton.vue';
import BCard from 'src/shared/components/base/BCard/BCard.vue';

const { required } = useValidators();
// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()

const code = ref('');

defineEmits<{
  login: [code: string];
}>();
</script>

<template>
  <BCard size="sm">
    <q-card-section>
      <p class="text-accent text-h5">{{ $t('CHILD_LOGIN_CARD_TITLE') }}</p>
      <ol class="text-body1 text-left text-white">
        <li>
          <p>
            {{ $t('CHILD_LOGIN_CARD_STEP_1') }}
          </p>
        </li>
        <li>
          <p>
            {{ $t('CHILD_LOGIN_CARD_STEP_2') }}
          </p>
        </li>
      </ol>
    </q-card-section>
    <q-form @submit="$emit('login', code)">
      <q-card-section class="flex justify-center">
        <BInput
          v-model="code"
          dark
          label="Login"
          color="primary"
          :rules="[required]"
          style="width: 280px"
        />
      </q-card-section>
      <q-card-actions class="flex justify-center">
        <BButton
          label="Login"
          color="accent"
          text-color="dark"
          type="submit"
        />
      </q-card-actions>
    </q-form>
    <q-card-actions class="flex justify-center">
      <slot name="actions" />
    </q-card-actions>
  </BCard>
</template>
